import React, {useState, useEffect} from "react"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import {useOnUpdate} from "../hooks"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"

export default function SenarioCategory({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {locale, perspective, mainCategory, categoryList, senarioCategoryIds, rankingListParam, rankingListTarget},
  } = useStore()

  const getValue = () => {
    let value = categoryList[perspective].find((h) => h.value === rankingListParam[perspective].category)
    if (!value) {
      value = {
        type: null,
        value: null,
        key: null,
        label: ``,
        labelEn: ``,
        labelJa: ``,
      }
    }
    return value
  }

  const setValue = (v) => {
    if (rankingListTarget.category === v.value)
      return
    dispatch({
      type: `RANKING_LIST_TARGET`,
      category: v.value
    })
  }

  const handleChange = (v) => {
    if (id !== senarioCategoryIds[perspective])
      return
    if (!v)
      setValue({
        type: null,
        value: null,
        key: null,
        label: ``,
        labelEn: ``,
        labelJa: ``,
      })
    else
      setValue(v)
  }
  
  const [key, setKey] = useState(false)
  const useSenarioCategory = () => {
    setKey(!key)
  }
  useOnUpdate(useSenarioCategory, [locale])

  useEffect(() => {
    setValue(getValue())
  }, [perspective])

  const label = t(mainCategory[perspective]) /* i18next-extract-disable-line */
  return mainCategory[perspective] === `undefined` ?
    null : (
    <VirtualSelect
      id={id}
      key={key}
      target={`senarioCategory`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={label}
      options={categoryList[perspective]}
      onChange={handleChange}
      value={getValue()}
    />
  )
}
